import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Stack,
  Alert
} from '@mui/material';
import {
  CheckCircle as EnabledIcon,
  Cancel as DisabledIcon
} from '@mui/icons-material';

interface ModelPricing {
  name: string;
  codename: string;
  credits: string;
  usdCost: string;
  plnCost: string;
  avgTime: string;
  enabled: boolean;
  description: string;
  apiKey?: string;
}

const EXCHANGE_RATE = 4.0; // PLN/USD

const modelPricingData: ModelPricing[] = [
  {
    name: 'Strawberry',
    codename: 'strawberry',
    credits: '1',
    usdCost: '$0.01',
    plnCost: '0.04 zł',
    avgTime: '~20s',
    enabled: true,
    description: 'Szybkie próby modelek i odzieży',
    apiKey: 'GEMINI_API_KEY_TULIPANOW'
  },
  {
    name: 'Strawberry Pro',
    codename: 'strawberry-pro',
    credits: '2-4',
    usdCost: '$0.02-0.04',
    plnCost: '0.08-0.16 zł',
    avgTime: '~30s',
    enabled: true,
    description: 'Produkcyjna jakość 4K, fotorealizm • 1K: 2 kredyty • 2K: 3 kredyty • 4K: 4 kredyty',
    apiKey: 'GEMINI_API_KEY_TULIPANOW'
  },
  {
    name: 'Strawberry Pro 2',
    codename: 'strawberry-pro2',
    credits: '2-3',
    usdCost: '$0.02-0.04',
    plnCost: '0.08-0.16 zł',
    avgTime: '~15s',
    enabled: true,
    description: 'Domyślny model (dressing-room, makeup, hairdresser) • Gemini 3.1 Flash Image Preview, max 10 refs',
    apiKey: 'GEMINI_API_KEY_TULIPANOW'
  },
  {
    name: 'Plum v2',
    codename: 'plum-v2',
    credits: '2-15',
    usdCost: 'subskrypcja',
    plnCost: 'subskrypcja',
    avgTime: '~30s',
    enabled: true,
    description: 'OpenAI gpt-image-2 przez Codex/ChatGPT OAuth • 1024x1024 do 4K • koszt kredytów zależny od size/quality',
    apiKey: 'PLUM_V2_BEARER_TOKEN'
  },
  {
    name: 'Plum v2 Fast',
    codename: 'plumv2-fast',
    credits: '1-24',
    usdCost: '$0.005-0.43+',
    plnCost: '0.02-1.72 zł+',
    avgTime: '~15s',
    enabled: true,
    description: 'OpenAI gpt-image-2 przez Images API • domyślnie low/JPEG • koszt API tokenowy: output + text/image input',
    apiKey: 'OPENAI_API_KEY'
  },
  {
    name: 'Melon',
    codename: 'melon',
    credits: '1',
    usdCost: '$0.01',
    plnCost: '0.04 zł',
    avgTime: '-',
    enabled: false,
    description: 'Model wyłączony'
  },
  {
    name: 'Blueberry',
    codename: 'blueberry',
    credits: '1',
    usdCost: '$0.01',
    plnCost: '0.04 zł',
    avgTime: '-',
    enabled: true,
    description: 'Legacy - zastąpiony przez Blueberry 4.5',
    apiKey: 'API_KEY_DEV_AIMLAPI'
  },
  {
    name: 'Blueberry 4.5',
    codename: 'blueberry-45',
    credits: '1',
    usdCost: '$0.01',
    plnCost: '0.04 zł',
    avgTime: '~30s',
    enabled: true,
    description: 'Bielizna, underwear (safety bypass), SeedDream 4.5',
    apiKey: 'API_KEY_DEV_AIMLAPI'
  },
  {
    name: 'Kiwi / Kiwi-R',
    codename: 'kiwi',
    credits: '1',
    usdCost: '$0.01',
    plnCost: '0.04 zł',
    avgTime: '-',
    enabled: true,
    description: 'RunPod endpoint'
  },
  {
    name: 'Lemon Lux',
    codename: 'lemon-lux',
    credits: '3',
    usdCost: '$0.03-0.12',
    plnCost: '0.12-0.48 zł',
    avgTime: '~10s',
    enabled: true,
    description: 'FLUX.2 Pro, multi-ref (8 obrazów), koszt API: $0.03/MP',
    apiKey: 'API_KEY_DEV_AIMLAPI'
  },
  {
    name: 'Lemon Max',
    codename: 'lemon-max',
    credits: '3',
    usdCost: '$0.03',
    plnCost: '0.12 zł',
    avgTime: '~20s',
    enabled: true,
    description: 'FLUX.2 Max Edit (AIMLAPI), 1-3 refs, image-to-image',
    apiKey: 'API_KEY_DEV_AIMLAPI'
  },
  {
    name: 'Lemon Max2 Edit',
    codename: 'lemon-max2-edit',
    credits: '3',
    usdCost: '$0.03',
    plnCost: '0.12 zł',
    avgTime: '~20s',
    enabled: true,
    description: 'FLUX.2 Max (direct BFL), 1-8 refs, edycja obrazów',
    apiKey: 'BLACKFOREST_FLUX'
  },
  {
    name: 'Turbo Snail',
    codename: 'turbo-snail',
    credits: '1',
    usdCost: '$0.02',
    plnCost: '0.08 zł',
    avgTime: '~11s',
    enabled: true,
    description: 'Alibaba 6B, ultra-fast fallback, no safety filter, accepts underwear/explicit',
    apiKey: 'API_KEY_DEV_AIMLAPI'
  },
  {
    name: 'BEAR Aurora',
    codename: 'bear-aurora',
    credits: '2',
    usdCost: '$0.02',
    plnCost: '0.08 zł',
    avgTime: '~15s',
    enabled: true,
    description: 'xAI GROK Aurora, text-to-image only (no reference images)'
  }
];

const operationPricing = [
  { name: 'Video', credits: '4', usdCost: '$0.04', plnCost: '0.16 zł' },
  { name: 'Upscale', credits: '1', usdCost: '$0.01', plnCost: '0.04 zł' },
  { name: 'Hand Fix', credits: '1', usdCost: '$0.01', plnCost: '0.04 zł' },
  { name: 'Make Real', credits: '1', usdCost: '$0.01', plnCost: '0.04 zł' },
  { name: 'Photo Tools (mask/combine/convert/lingerie)', credits: '0', usdCost: 'Darmowe', plnCost: 'Darmowe' }
];

const PricingInfo: React.FC = () => {
  return (
    <Stack spacing={3}>
      {/* Header */}
      <Box>
        <Typography variant="h5" gutterBottom>
          Cennik - Modele Generacji
        </Typography>
        <Alert severity="info" sx={{ mb: 2 }}>
          Kurs wymiany: 1 USD = {EXCHANGE_RATE} PLN • 1 kredyt = $0.01 (w większości przypadków)
        </Alert>
      </Box>

      {/* Models Pricing Table */}
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'action.hover' }}>
              <TableCell><strong>Model</strong></TableCell>
              <TableCell><strong>Codename</strong></TableCell>
              <TableCell align="center"><strong>Status</strong></TableCell>
              <TableCell align="right"><strong>Kredyty</strong></TableCell>
              <TableCell align="right"><strong>USD</strong></TableCell>
              <TableCell align="right"><strong>PLN</strong></TableCell>
              <TableCell align="center"><strong>Czas</strong></TableCell>
              <TableCell><strong>Opis</strong></TableCell>
              <TableCell><strong>Klucz API</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {modelPricingData.map((model) => (
              <TableRow
                key={model.codename}
                sx={{
                  '&:hover': { backgroundColor: 'action.hover' },
                  opacity: model.enabled ? 1 : 0.6
                }}
              >
                <TableCell>
                  <Typography variant="body2" fontWeight="medium">
                    {model.name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="caption" sx={{ fontFamily: 'monospace', color: 'text.secondary' }}>
                    {model.codename}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  {model.enabled ? (
                    <Chip
                      icon={<EnabledIcon />}
                      label="Enabled"
                      size="small"
                      color="success"
                      variant="outlined"
                    />
                  ) : (
                    <Chip
                      icon={<DisabledIcon />}
                      label="Disabled"
                      size="small"
                      color="default"
                      variant="outlined"
                    />
                  )}
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" fontWeight="bold" color="primary">
                    {model.credits}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2">
                    {model.usdCost}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2">
                    {model.plnCost}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="caption" color="text.secondary">
                    {model.avgTime}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="caption" color="text.secondary">
                    {model.description}
                  </Typography>
                </TableCell>
                <TableCell>
                  {model.apiKey && (
                    <Typography variant="caption" sx={{ fontFamily: 'monospace', color: 'text.secondary', fontSize: '0.7rem' }}>
                      {model.apiKey}
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Operations Pricing */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Ceny Operacji
        </Typography>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: 'action.hover' }}>
                <TableCell><strong>Operacja</strong></TableCell>
                <TableCell align="right"><strong>Kredyty</strong></TableCell>
                <TableCell align="right"><strong>USD</strong></TableCell>
                <TableCell align="right"><strong>PLN</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {operationPricing.map((op) => (
                <TableRow key={op.name} sx={{ '&:hover': { backgroundColor: 'action.hover' } }}>
                  <TableCell>
                    <Typography variant="body2">
                      {op.name}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2" fontWeight="bold" color="primary">
                      {op.credits}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2">
                      {op.usdCost}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2">
                      {op.plnCost}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Rate Limits Info */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Limity Dzienne (Rate Limits)
        </Typography>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: 'action.hover' }}>
                <TableCell><strong>Model</strong></TableCell>
                <TableCell align="right"><strong>Per Minute</strong></TableCell>
                <TableCell align="right"><strong>Per Day</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Strawberry</TableCell>
                <TableCell align="right">500</TableCell>
                <TableCell align="right">2000</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Strawberry Pro</TableCell>
                <TableCell align="right">20</TableCell>
                <TableCell align="right"><strong style={{ color: 'red' }}>250</strong></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Strawberry Pro 2</TableCell>
                <TableCell align="right">20</TableCell>
                <TableCell align="right">1000</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Plum v2</TableCell>
                <TableCell align="right">20</TableCell>
                <TableCell align="right">500</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Plum v2 Fast</TableCell>
                <TableCell align="right">OpenAI quota</TableCell>
                <TableCell align="right">OpenAI quota</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Blueberry / Blueberry 4.5</TableCell>
                <TableCell align="right">120</TableCell>
                <TableCell align="right">3000</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Lemon (Lux/Max/Max2)</TableCell>
                <TableCell align="right">20</TableCell>
                <TableCell align="right">200</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>BEAR Aurora</TableCell>
                <TableCell align="right">10</TableCell>
                <TableCell align="right">100</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Alert severity="warning" sx={{ mt: 2 }}>
          <strong>⚠️ Strawberry Pro:</strong> Tylko 250 zdjęć dziennie! Planuj użycie odpowiednio.
        </Alert>
      </Box>
    </Stack>
  );
};

export default PricingInfo;
